
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', { 'className': 'product-card card-' + this.id }, _createElement('div', { 'className': '#product-card-badges @position:left badges' }, this.on_sale && this.compare_at_price > this.price ? _createElement('div', {
                    'className': '#badge @type:sale badge-sale',
                    'key': '105'
                }, '\n      ', Math.ceil((1 - this.price / this.compare_at_price) * 100), '% Off\n    ') : null), _createElement('div', { 'className': '#product-card-media product-card-media' }, _createElement('div', { 'className': '#product-card-carousel-tiles product-card-carousel-tiles' }, this.image ? _createElement('a', {
                    'tabIndex': '-1',
                    'href': this.url,
                    'className': '#product-card-carousel-tile carousel-tile',
                    'data-image-url': this.resizeImage(this.image),
                    'data-carousel-tile': '1',
                    'data-product-id': this.id,
                    'key': '449'
                }) : null, this.image2 ? _createElement('a', {
                    'tabIndex': '-1',
                    'href': this.url,
                    'className': '#product-card-carousel-tile carousel-tile',
                    'data-image-url': this.resizeImage(this.image2),
                    'data-carousel-tile': '2',
                    'data-product-id': this.id,
                    'key': '660'
                }) : null, this.image3 ? _createElement('a', {
                    'tabIndex': '-1',
                    'href': this.url,
                    'className': '#product-card-carousel-tile carousel-tile',
                    'data-image-url': this.resizeImage(this.image3),
                    'data-carousel-tile': '3',
                    'data-product-id': this.id,
                    'key': '873'
                }) : null, this.image4 ? _createElement('a', {
                    'tabIndex': '-1',
                    'href': this.url,
                    'className': '#product-card-carousel-tile carousel-tile',
                    'data-image-url': this.resizeImage(this.image4),
                    'data-carousel-tile': '4',
                    'data-product-id': this.id,
                    'key': '1086'
                }) : null, this.image5 ? _createElement('a', {
                    'tabIndex': '-1',
                    'href': this.url,
                    'className': '#product-card-carousel-tile carousel-tile',
                    'data-image-url': this.resizeImage(this.image5),
                    'data-carousel-tile': '5',
                    'data-product-id': this.id,
                    'key': '1299'
                }) : null), _createElement('div', { 'className': 'product-card-media-inner' }, _createElement('div', { 'className': '#media' }, _createElement('img', {
                    'className': '#media-image media-image',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                })))), _createElement('div', { 'className': 'product-card-carousel-pagination' }, this.image && this.image2 ? _createElement('div', {
                    'className': 'product-card-carousel-pagination-item active',
                    'data-carousel-pagination': '1',
                    'key': '1846'
                }, _createElement('span', {})) : null, this.image2 ? _createElement('div', {
                    'className': 'product-card-carousel-pagination-item',
                    'data-carousel-pagination': '2',
                    'key': '2006'
                }, _createElement('span', {})) : null, this.image3 ? _createElement('div', {
                    'className': 'product-card-carousel-pagination-item',
                    'data-carousel-pagination': '3',
                    'key': '2137'
                }, _createElement('span', {})) : null, this.image4 ? _createElement('div', {
                    'className': 'product-card-carousel-pagination-item',
                    'data-carousel-pagination': '4',
                    'key': '2268'
                }, _createElement('span', {})) : null, this.image5 ? _createElement('div', {
                    'className': 'product-card-carousel-pagination-item',
                    'data-carousel-pagination': '5',
                    'key': '2399'
                }, _createElement('span', {})) : null), _createElement('div', { 'className': 'product-card-caption' }, _createElement('div', { 'className': '#product-card-caption-inner' }, _createElement('p', mergeProps({ 'className': '#product-card-vendor product-card-vendor' }, { dangerouslySetInnerHTML: { __html: this.vendor } })), _createElement('h3', { 'className': '#product-card-title product-card-title' }, _createElement('span', mergeProps({ 'className': '#text-truncate' }, { dangerouslySetInnerHTML: { __html: this.title } }))), _createElement('div', { 'className': '#product-card-price product-card-price' }, _createElement('dl', { 'className': '#price price' }, _createElement('div', { 'className': '#price-item @regular' }, _createElement('dd', { 'className': '#price-item-value' }, _createElement('span', { 'className': '#price-value' }, this.custom_set_quantity ? _createElement('div', {
                    'className': 'set-pricing-container',
                    'key': '3147'
                }, _createElement('span', { 'className': 'price-set' }, ' ', this.formatPrice(this.price * this.custom_set_quantity), ' '), _createElement('span', { 'className': 'price-label' }, 'set of ', this.custom_set_quantity)) : null, !this.custom_set_quantity ? _createElement('div', {
                    'className': 'product-card-price',
                    'key': '3449'
                }, '\n                  ', this.formatPrice(this.price), '\n                ') : null))), this.on_sale ? _createElement('div', {
                    'className': '#price-item @compare price-item-compare',
                    'key': '3655'
                }, _createElement('dd', { 'className': '#price-item-value' }, _createElement('span', { 'className': '#price-value' }, this.custom_set_quantity ? _createElement('div', {
                    'className': 'set-pricing-container',
                    'key': '3831'
                }, _createElement('span', { 'className': 'price-set' }, '\n                    ', this.formatPrice(this.compare_at_price * this.custom_set_quantity), '\n                  '), _createElement('span', { 'className': 'price-label' }, 'set of ', this.custom_set_quantity)) : null, !this.custom_set_quantity ? _createElement('div', {
                    'className': 'product-card-price',
                    'key': '4182'
                }, '\n                  ', this.formatPrice(this.compare_at_price), '\n                ') : null))) : null))), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '4431'
                }) : null, this.estimated_delivery ? _createElement('div', {
                    'className': '#product-card-delivery arrival-date',
                    'key': '4566'
                }, '\n      Estimated Arrival:\n      ', _createElement('strong', {}, ' ', this.estimated_delivery, ' ')) : null));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []